export const environment = {
  production: false,
  maintenance: false,
  apiURL: "https://dev.attorneys.georgiabar.org/api",
  atsSsoUrl: 'https://sbga.atsservices.net/efilesso/ssobytoken.aspx',
  clientAppUrl: 'https://dev-attorney-portal.azurewebsites.net',
  legacyCleUrl: 'https://dev-legacy-pages.azurewebsites.net/CheckCLE_PrevYearCourses.asp',
  ClientAppSettings: {
    gaBarUrl: 'https://dev.gabar.org'
  },
  paymentApiURL: "https://dev.portals.georgiabar.org/api",
};

